import type { CommissionStatementFileDto, CommissionStatementFileFormat } from 'korint-sdk';
import { Button, buttonVariants } from '../../../components/ui/button';

export function FileButton({
  format,
  file,
}: {
  format: CommissionStatementFileFormat;
  file?: CommissionStatementFileDto;
}) {
  if (!file) {
    return (
      <Button variant="outline" size="sm" disabled>
        {format}
      </Button>
    );
  }

  return (
    <a
      href={file.signedUrl}
      download={file.name}
      className={buttonVariants({ variant: 'outline', size: 'sm' })}
    >
      {file.format}
    </a>
  );
}
